import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Title from '../Title';
import SubscriptionCard from './Card';
import SubscriptionForm from './Form';

import './styles.scss';

const Subscription = () => {
  const subscriptionDataPopup = useSelector((state) => state.stripe.subscriptionDataPopup);
  const [data, setData] = useState([]);
  const [activeSubscription, setActiveSubscription] = useState({})

  const calbackHandler = (key) => {
    setActiveSubscription((prev) => {
      for(let obj in prev) {
        prev[obj] = false
      }
      prev[key] = true;

      return {...prev}
    })
  };

  useEffect(() => {
    const filterData = [];
    const activeSubscriptionObj = {};
  
    for(let key in subscriptionDataPopup) {
      const obj = subscriptionDataPopup[key];
      const newObj = {...obj};
      newObj.key = key;
      filterData.push(newObj);
      activeSubscriptionObj[key] = false
    }

    setActiveSubscription(activeSubscriptionObj);
    setData(filterData);

  },[subscriptionDataPopup])

  return (
    <div className="subscription">
      <Title text="Free Limit Reached" isBig isWhite isBold/>
      <p className="subscription__subtitle">
        Your 90 day trial has expired please subscribe to continue using the service!
      </p>
      {data.map((card,i) => (
        <SubscriptionCard 
          key={i} 
          data={card} 
          callback={calbackHandler} 
          activeSubscription={activeSubscription}
        />
      ))}
      <SubscriptionForm activeSubscription={activeSubscription}/>
    </div>
  );
};

export default Subscription;
